<template>
	<v-container fluid class="pa-0 fill-height" style="display:flex; flex-grow: 1;">
		<div v-if="loading" class="d-flex flex-column align-center justify-center" style="width: 100%">
			<v-progress-circular
				:size="50"
				:width="2"
				color="#2D4B95"
				indeterminate
			></v-progress-circular>
			<div class="mt-4">Cargando Documento</div>
		</div>
		<v-card v-else-if="item" class="fm-document-viewer pa-0 fill-height">
			<div class="d-flex align-center justify-space-between fm-document-header">
				<img :src="require('@/assets/Svg/logoWhite.svg')" style="max-width: 110px; width: 100%;"/>
				<div class="d-flex align-center">
					<v-icon class="mr-3" color="white">{{ getFileIcon }}</v-icon>
					<div class="font-weight-medium text-truncate">{{ item.name }}</div>
				</div>
				<div class="d-flex align-center" style="gap: 8px;">
					<v-chip small outlined color="white" label>{{ getFileInfo }}</v-chip>
					<div v-if="openMorphableText && fromInternalView">
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									small
									color="white"
									@click="$emit('open-morphable', item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>{{ openMorphableIcon }}</v-icon>
								</v-btn>
							</template>
							<span>{{ openMorphableText }}</span>
						</v-tooltip>
					</div>
					<RevisionFileSelector
						:revision-context="revisionContext"
						:current-file-id="item.id"
						:loading="revisionLoading"
						@select="selectRevision"
					/>
					<div>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									small
									:href="item.pathdoc?.path"
									target="_blank"
									color="white"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>mdi-download</v-icon>
								</v-btn>
							</template>
							<span>Descargar archivo</span>
						</v-tooltip>
					</div>
					<v-btn icon small @click="minimizeItem" class="ml-1" color="white" v-if="fromInternalView">
						<v-icon>mdi-minus</v-icon>
					</v-btn>
					<v-btn icon small @click="closeDialog" class="ml-1" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>
			</div>
			<v-card-text class="fm-document-content pa-0">
				<ForgeViewer :forge-selected-file="item" />
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import { getFile } from '@/helpers/api/files'
import ForgeViewer from '@/components/Views/Planimetria/ForgeViewer'
import RevisionFileSelector from '@/components/Globals/Helpers/RevisionFileSelector'

export default {
  name: 'StandaloneForgeViewer',
	components: { ForgeViewer, RevisionFileSelector },
  props: {
    itemProp: {
      type: Object,
      default: null
    },
		fromInternalView: {
			type: Boolean,
			default: false
		}
  },
  data() {
    return {
      loadFailed: false,
      isOpen: false,
			item_id: null,
			item: null,
					loading: true,
					revisionContext: null,
					revisionLoading: false
    }
  },
  watch: {
    item(newVal) {
      if (newVal) {
        this.isOpen = true
      }
    }
  },
  computed: {
    getFileIcon() {
      return 'mdi-file-cad'
    },
    getFileInfo() {
      const ext = this.item?.ext?.toUpperCase() || 'ARCHIVO'
      const size = this.getFileSize()
      return `${ext}${size ? ` • ${size}` : ''}`
    },
		openMorphableText(){
			if(!this.item || !this.item.morphable_type) return null
			if(this.item.morphable_type === 'App\\Models\\TasksRestrictions' || this.item.morphable_type === 'App\\Models\\TasksRestrictionsInteractions'){
				return 'Abrir Tarea Asociada'
			}
			else if(this.item.morphable_type === 'App\\Models\\Rdi' || this.item.morphable_type === 'App\\Models\\RdiInteractions'){
				return 'Abrir RDI Asociada'
			}
			else if(this.item.morphable_type === 'App\\Models\\Additional' || this.item.morphable_type === 'App\\Models\\AdditionalRevision' || this.item.morphable_type === 'App\\Models\\AdditionalObservation'){
				return 'Abrir Adicional Asociado'
			}
			return null
		},
		openMorphableIcon(){
			if(!this.item || !this.item.morphable_type) return null
			if(this.item.morphable_type === 'App\\Models\\TasksRestrictions' || this.item.morphable_type === 'App\\Models\\TasksRestrictionsInteractions'){
				return 'mdi-clipboard-text-outline'
			}
			else if(this.item.morphable_type === 'App\\Models\\Rdi' || this.item.morphable_type === 'App\\Models\\RdiInteractions'){
				return 'mdi-file-document-multiple-outline'
			}
			else if(this.item.morphable_type === 'App\\Models\\Additional' || this.item.morphable_type === 'App\\Models\\AdditionalRevision' || this.item.morphable_type === 'App\\Models\\AdditionalObservation'){
				return 'mdi-notebook-plus-outline'
			}
			return null
		}
  },
	mounted() {
		// Si recibe el item como prop, usarlo directamente
		if (this.itemProp) {
			this.item = this.itemProp
			this.$store.forgeStore.commit('setForgeSelectedFile', this.item)
			this.loading = false
			this.loadRevisionContext(this.item.id)
			return
		}

		// Si no, obtenerlo de la ruta
		this.item_id = this.$route.query?.item_id || this.$route.params?.item
		if(this.item_id){
			this.getItem()
		}
	},
  methods: {
		async getItem() {
			this.loading = true
			const file = await getFile({ file_id: this.item_id })
			if(file.code == 200){
				this.item = file.data
				this.revisionContext = file.revision_context
				this.$store.forgeStore.commit('setForgeSelectedFile', this.item)
			} else {
				this.loadFailed = true
			}
			this.loading = false
		},
		async loadRevisionContext(fileId) {
			this.revisionLoading = true
			try {
				const response = await getFile({ file_id: fileId })
				if (response.code === 200) this.revisionContext = response.revision_context
			} finally {
				this.revisionLoading = false
			}
		},
		selectRevision(item) {
			if (!item?.id) return
			if (!item.forge_file?.translated) {
				this.$store.globalStore.dispatch('addMessage', {
					message: 'Esta revision aun no esta disponible en el visor Autodesk.',
					title: 'Revision no traducida',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#FB8500'
				})
				return
			}
			this.item = item
			this.$store.forgeStore.commit('setForgeSelectedFile', item)
		},

    onIframeError() {
      this.loadFailed = true
    },

    onIframeLoad() {
      this.loadFailed = false
    },

		minimizeItem() {
			this.$store.globalStore.commit('addFileToFileManagerHandler', this.item)
			this.closeDialog()
		},

    closeDialog() {
      this.isOpen = false
      this.$emit('close')
			window.close()
    },
    getFileSize() {
      const size = this.item?.size
      if (!size) return null
      if (size < 1024) return `${size} B`
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`
      return `${(size / (1024 * 1024)).toFixed(2)} MB`
    }
  }
}
</script>

<style scoped>
.fm-document-viewer {
  display: flex;
  flex-direction: column;
  height: 100vh;
	width: 100vw;
	max-height: 100vh;
	max-width: 100vw;
}

.fm-document-header {
  border-bottom: 1px solid #213872;
  padding: 8px 16px !important;
  background: #2D4B95;
	color: white;
}

.fm-document-header .v-toolbar__content {
  padding: 0 !important;
}

.fm-document-content {
  flex: 1;
  overflow-y: auto;
  background: #fafafa;
}

.document-viewer-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-viewer-iframe {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  border: none;
}
</style>
